import React from 'react';
import './Benefits.css';

const Benefits: React.FC = () => {
  const sections = [
    {
      id: 1,
      title: "About The Collective at Gateway",
      description: "Experience the advantages of our premium workspace solution",
      items: [
        "Flexible work solutions for professionals and businesses, including:",
        "Private offices for your business needs",
        "Meeting rooms to collaborate with teams",
        "Memberships with access to the coworking community and amenities"
      ]
    },
    {
      id: 2,
      title: "What We Offer",
      items: [
        "Convenient location with easy access to major highways, and local amenities",
        "Quiet and comfortable work environment",
        "Ability to transfer into a traditional office seamlessly"
      ]
    },
    {
      id: 3,
      title: "Customizable Solutions",
      items: [
        "Choose from MTM or longer term leases to suit your business needs with simple transparent pricing",
        "Scalable options to fit your business growth"
      ]
    },
    {
      id: 4,
      title: "Amenities",
      items: [
        "Community kitchen with free refreshments",
        "Super-fast and secure WiFi",
        "Beautiful and peaceful outdoor space to recharge during the day"
      ]
    }
  ];

  return (
    <section id="benefits" className="benefits">
      <div className="container">
        <div className="benefits-grid">
          {sections.map((section) => (
            <div key={section.id} className="benefits-section">
              <h2>{section.title}</h2>
              {section.description && <p className="section-description">{section.description}</p>}
              <ul className="benefits-list">
                {section.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits; 